import api from "./axios";

// Users
export const listUsers = () => api.get("/admin/users");
export const createUser = (data) => api.post("/admin/users", data);
export const updateUser = (userId, data) => api.put(`/admin/users/${userId}`, data);
export const deleteUser = (userId) => api.delete(`/admin/users/${userId}`);

// File access
export const grantFileAccess = (userId, fileId) =>
  api.post(`/admin/users/${userId}/file-access`, { file_id: fileId });
export const revokeFileAccess = (userId, fileId) =>
  api.delete(`/admin/users/${userId}/file-access/${fileId}`);

// Admin file management
export const adminListFiles = () => api.get("/admin/files");
export const approveFile = (fileId) => api.post(`/admin/files/${fileId}/approve`);
export const rejectFile = (fileId) => api.post(`/admin/files/${fileId}/reject`);
export const reindexAll = () => api.post("/admin/reindex-all");
export const getFileSharedUsers = (fileId) => api.get(`/admin/files/${fileId}/shared-users`);
export const shareFileWithUsers = (fileId, userIds) =>
  api.post(`/admin/files/${fileId}/share`, { user_ids: userIds });

// Settings
export const getSettings = () => api.get("/settings");
export const updateSettings = (settings) => api.put("/settings", { settings });
export const getLlmStatus = () => api.get("/settings/llm-status");

// Ollama available models
export const getOllamaModels = () => api.get("/admin/ollama/models");

// Ollama model pull (SSE streaming)
export const pullOllamaModel = (model) => {
  const token = localStorage.getItem("access_token");
  const base = process.env.REACT_APP_API_URL || "/api";
  return fetch(`${base}/admin/ollama/pull`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ model }),
  });
};
